import types from './types'

export class Plugin{
    constructor(name, props){
        this.name = name;
        this.$props = props || {};
        this.$options = {}
    }

    initialize(options){
        Object.entries(this.$props).forEach(([key, definition])=>{
            var value = options[key];
            if(typeof value === types.undefined){
                if(definition.required)
                    throw `Required argument ${key} is not defined`
                value = definition.default;
                if(typeof value === types.function)
                    value =  value(this);
            }
            
            options[key] = value;
        });
        this.$options = options;
    }
}

export class PluginContainer extends Plugin{
    constructor(name, props){
        super(name, props);
        this.$plugins = {}
    }

    use(plugin, props){
        var name = plugin.name;
        if(!name)
            throw 'Each plugin has to define a name';
        
        if(this.$plugins[name])
            throw `A plugin with name is already ${name} defined`

        this.$plugins[name] = plugin;

        props = props || {};
        
        this.inject(props);
        plugin.initialize(props);
    }

    inject(){}
}